import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { TicketService } from 'src/app/Services/ticket/ticket.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.css']
})
export class TicketComponent implements OnInit {


  Submitted: boolean = false;
  Action: any = "Add";
  constructor( public router:Router,private ticketservice: TicketService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { 
     
    }

    SearchModel = {
      TicketNo:'',
      SchoolID:0,
      BranchID:0,
      DepartmentID: 0,
      TicketStatusID:0,
      CurrentIndex: 0,
      PageSize: 20,
    }

    ClearSearch(){
      this.SearchModel.TicketNo='';
      this.SearchModel.SchoolID=0;
      this.SearchModel.BranchID=0;
      this.SearchModel.DepartmentID=0;
      this.SearchModel.TicketStatusID=0;
      this.TicketList=[];
    }
  TicketList: any;
  GetALLTicket() {
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.spinnerService.show();
    this.ticketservice.GetALLTicket(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.TicketList = response.TicketList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.recordCount = 0;
      if (response.TicketList != null && response.TicketList.length > 0) {
          this.recordCount = response.TicketList[0].RecordCount;
      }
      this.numberOfPages();
    });
  };

  CloseTicket(TicketID) {
    if (confirm("Are you sure to close the ticket!")) {
      this.spinnerService.show();
      this.ticketservice.CloseTicket(TicketID).subscribe((response: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        this.GetALLTicket();
      });
    }
  };
  ngOnInit() {
    this.SearchModel.TicketStatusID = window.history.state.TicketStatusID;
    if (this.SearchModel.TicketStatusID == undefined) {
      this.SearchModel.TicketStatusID = 0;
    }
    this.GetAllSchool();
    this.GetDepartment();
    this.GetTicketStatus();
    this.GetALLTicket();   
  }

  SchoolList: any;
  GetAllSchool() {   
    this.lookupservice.GetLookupsList('School','').subscribe((data: any) => {
      this.SchoolList = data.LookupItems;

    });
  };
  BranchList: any;
  GetSchoolBranch() {  
    var item = {
      'SchoolID': this.SearchModel.SchoolID
    }
    this.lookupservice.GetLookupsList('TicketBranchSchool',JSON.stringify(item)).subscribe((data: any) => {
      this.BranchList = data.LookupItems;

    });
  };
  DepartmentList: any;
  GetDepartment() {
    this.lookupservice.GetLookupsList('TicketDepartment', '').subscribe((data: any) => {
      this.DepartmentList = data.LookupItems;

    });
  };
  TicketStatusList: any;
  GetTicketStatus() {
    this.lookupservice.GetLookupsList('TicketStatus', '').subscribe((data: any) => {
      this.TicketStatusList = data.LookupItems;

    });
  };

  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
   this.totalPages = Math.ceil(this.recordCount / this.pageSize);
   }

   nextPage() {
   this.currentPage = this.currentPage + 1;
   }

   pageSizes() {
   this.currentPage = 1;
   this.recordCount = 0;
   this.totalPages = 0;
   }

}